export function FieldError({ id, error }: { id: string; error: string | null }) {
  if (!error) return null;
  return (
    <p id={`${id}-error`} className="hsab-calc__field-error" role="alert">
      {error}
    </p>
  );
}
